import { Injectable } from '@angular/core';
import { CacheService } from 'projects/common/src/app/services';
import { Parameter } from 'projects/common/src/app/classes';
import { ISession } from 'projects/common/src/app/interfaces/authentication';

/**
 * Servicio parámetro que manejará el valor del token de sesión.
 *
 * Se modifican sus métodos ``get`` ``set`` para guardar en localstorage
 * en lugar de una variable local.
 */
@Injectable({
  providedIn: 'root'
})
export class TokenService extends Parameter<ISession> {

  protected get target(): ISession {
    return this.cacheService.local(this.name);
  }
  protected set target(value: ISession) {
    this.cacheService.saveLocal(this.name, value);
    this.sourceSubject.next(value);
  }

  constructor(
    private cacheService: CacheService
  ) {
    super();
    this.name = 'session';
  }

  public start(): Promise<ISession> {
    return new Promise((resolve) => {
      const currentToken = this.get();
      this.set(currentToken);
      resolve(currentToken);
    });
  }
}
